import { io } from 'socket.io-client';

import { WEB_SOCKET_URL } from '../configs';

export const socket = io(WEB_SOCKET_URL);
